import React, { Fragment, useEffect, useState, useRef } from 'react'
import wx from 'weixin-js-sdk'
import { url_xc } from '../../utils/http'
import './index.scss';
const Authorization = () => {
    const [studentNo, setStudentNo] = useState('')
    const [code, setCode] = useState('')
    const [isloading, setisloading] = useState(true)
    const [userName, setUserName] = useState('')
    useEffect(() => {
        const searchParams = new URLSearchParams(window.location.search)
        if (searchParams.get('code')) {
            setCode(searchParams.get('code'))
            getDetail(searchParams.get('code'))
        }
        window.document.title = '趣智后勤热水'
        // this.WxInit()
    }, [])
    const WxInit = () => {
        fetch('/api/wechat-signature')
            .then(res => res.json())
            .then(data => {
                wx.config({
                    debug: true,
                    appId: data.appId,
                    timestamp: data.timestamp,
                    nonceStr: data.nonceStr,
                    signature: data.signature,
                    jsApiList: ['launchMiniProgram']
                });
            });
    }
    const getDetail = async (val) => {
        let url = `${url_xc}/combination/cas/jsdx/validate?code=${val}`
        fetch(url).then(res => {
            return res.json()
        }).then(res => {
            setisloading(false)
            if (res.data) {
                let data = res.data
                console.log(data)
                setStudentNo(data.studentNo)
                setUserName(data.userName)
            }
        })
    }
    const goWx = () => {
        const isWeChat = /MicroMessenger/i.test(navigator.userAgent);
        let that = this
        if (!isWeChat) {
            alert('请在微信中打开');
            return;
        }
        console.log('跳转微信')
        const params = JSON.stringify({
            userName: userName,
            studentNo: studentNo,
        })
        wx.miniProgram.reLaunch({
            url: `/pages/index/index?info=${params}`
        })
        return
    }

    return (
        <>
            {
                isloading && <div className='authorization-page'>
                    <div className='loading-text'>
                        正在跳转，请稍候...
                    </div>
                </div>
            }
            {
                !isloading && studentNo &&
                <div className='page-box'>
                    <div className='page-content'>
                        <div className='img-box'>
                            <div className='size-style'>学生信息</div>
                        </div>
                        <div className='detail-content'>
                            <div className='detail-box detail-active'>
                                <div>姓名：</div>
                                <div className='size-width'>{userName}</div>
                            </div>
                            <div className='detail-box'>
                                <div>学号：</div>
                                    <div className='size-width'>{studentNo}</div>
                            </div>
                        </div>
                    </div>
                    <div className='btn-box'>
                        <div className='btn-con' onClick={goWx}>去绑定</div>
                    </div>
                </div>
            }
            {
                isloading && !studentNo && <div className='authorization-page'>
                    <div className='loading-text'>
                        暂无数据
                    </div>
                </div>
            }

        </>
    )
}
export default Authorization;